import DashboardConfiguration from 'components/DynamicDashboard/DashboardConfiguration';
import i18n from 'i18n';
import React from 'react';
import { usePartnersDashboard } from './usePartnersDashboard';

interface PartnersDashboardConfigurationProps {
  filters: Record<string, string>;
  selectedCards: string[];
  setSelectedCards: React.Dispatch<React.SetStateAction<string[]>>;
}

const PartnersDashboardConfiguration = ({
  filters,
  selectedCards,
  setSelectedCards,
}: PartnersDashboardConfigurationProps) => {
  const dashboardProps = usePartnersDashboard({ filters });

  return (
    <DashboardConfiguration
      disableDashboardText={i18n.t('DONT_USE_PARTNERS_DASHBOARD_KEY')}
      selectedCards={selectedCards}
      setSelectedCards={setSelectedCards}
      {...dashboardProps}
    />
  );
};

export default PartnersDashboardConfiguration;
